import httpClient from "@/services/http.service"

const checkAccessService = {
    getCheckAccess(test_type) {
        return httpClient.get(`sei/total-percent/access-check?test_type=` + test_type)
    }
}

export default checkAccessService